import { getFileApiCall } from "./tokenService";

export const getDocument = (id: string): Promise<string> => {
    return getFileApiCall("api/document?id=" + (id || ""));
};